import React, { Fragment, useEffect, useState } from "react";
import { Select as AntSelect, Switch } from "antd";
import { CaretDownOutlined } from "@ant-design/icons";
import {
  Card,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  TextField,
  Dialog,
} from "@mui/material";
import CancelIcon from "@mui/icons-material/Cancel";
import { fetchBusinessUnits } from "../../../services/orgService";
import {
  emissionAvailableCategoriesService,
  getAllEmissionsService,
} from "../../../services/emissionService";
import "../EmissionTarget.scss";
import { DatePicker } from "antd";
import type { RangePickerProps } from "antd/es/date-picker";
import dayjs from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import { useNavigate, useLocation, useParams } from "react-router-dom";
import {
  CATEGORY_CODE,
  STEPS,
  TARGET_REDUCER_TYPES,
  TARGET_TYPES,
} from "../../../constants/enums";
import { useTranslation } from "react-i18next";
import BaselineYearDialog from "./BaselineYearDialog";
import FileAttachmentsDetails from "../../common/FileAttachmentsDetails";
import moment from "moment";
import RecentYearDialog from "./RecentYearDialog";
import TargetYearDialog from "./TargetYearDialog";

import { checkPermissions, toastMessage } from "../../../helper";
import { useSelector } from "react-redux";
import CategoryLevelDialog from "./CategoryLevelDialog";

dayjs.extend(customParseFormat);

const EmissionTarget = (props: any) => {
  const { t } = useTranslation();
  const {
    setStep,
    dispatch,
    targetState,
    setBaseValues,
    setTargetValues,
    setNetValues,
    categoryList,
    setCategoryList,
    categoriesByYears,
    setCategoriesByYears,
    selectedIndex,
    setSelectedIndex,
    // switchStates,
    // setSwitchStates,
    targetCoverage,
    setTargetCoverage,
    setTargetAlignment,
    createKey,
  } = props;

  const { state } = useLocation();
  const navigate = useNavigate();
  const permissions = useSelector((state: any) => state.auth.userPermissions);
  const [bunitList, setBunitsList] = useState<any>([]);
  const [OpenBaselineDialog, setOpenBaselineDialog] = useState(false);
  const [OpenRecentDialog, setOpenRecentDialog] = useState(false);
  const [OpenTargetDialog, setOpenTargetDialog] = useState(false);
  const [OpenDialog, setOpenDialog] = useState(false);
  const [baselineValueChanged, setBaselineValueChanged] = useState(false);
  const [scopeToDisplay, setScopeToDisplay] = useState<number>(0);
  const [currentScope, setcurrentScope] = useState<number>(0);
  const [targetRowId, setTargetRowId] = useState<number>(-1);
  const [categoryIndex, setCategoryIndex] = useState<number>(0);
  const [categoryTargetType, setCategoryTargetType] = useState<any>("");
  const [targetYear, setTargetYear] = useState<number>(0);
  const [selectedTargetYear, setSelectedTargetYear] = useState<number>(0);
  const [currentBaseline, setCurrentBaseline] = useState<any>({});
  const [currentTarget, setCurrentTarget] = useState<any>({});
  const [baselineYear, setBaselineYear] = useState<number>(0);
  const [mostRecentYearEmissionValue, setMostRecentYearEmissionValue] =
    useState<number>();
  const [emissionData, setEmissionData] = useState<any>([]);
  const [targetType, setTargetType] = useState<any>("");
  const [categoryData, setCategoryData] = useState<Map<string, any>>(new Map());
  const [categoryDataRecent, setCategoryDataRecent] = useState<
    Map<string, any>
  >(new Map());
  const [scopes, setScopes] = useState(
    new Map<string, { scope1: number; scope2: number; scope3: number }>()
  );
  const [attachmentsData, setAttachmentsData] = useState<any>({
    attachments: [],
  });
  const [showFileUpload, setShowFileUpload] = useState(false);
  const [currentTargetYear, setCurrentTargetYear] = useState<number>(0);
  const [currentCategoryId, setCurrentCategoryId] = useState<any>({});
  const [comments, setComments] = useState<string>("");
  const [isCategoryAttachments, setIsCategoryAttachments] = useState(false);
  const [editedValue, setEditedValue] = useState<number>(0);
  const [editableCell, setEditableCell] = useState<{
    year: string;
    scope: number;
    categoryId: number;
    column: string;
  } | null>(null);
  const [scopewiseData, setScopewiseData] = useState<{
    [key: string]: {
      totalEmissionValue: number;
      totalSbtValue: number;
      scopes: { [key: string]: number };
      sbtValues: { [key: string]: number };
    };
  }>({});

  const { Option } = AntSelect;
  const { id } = useParams();

  const isEdit = !!id;
  const cellColumns =
    selectedIndex < 3 && !OpenDialog
      ? ["Baseline year", "Emissions(tCO2e)", "", "Comments"]
      : ["Baseline year"];
  const cellColumnsRecentYear = [
    "Most Recent year",
    "Emissions(tCO2e)",
    "",
    "Comments",
  ];
  const cellColumnsTargetYear =
    selectedIndex < 3 && !OpenDialog
      ? [
          "Target year",
          "Emissions(tCO2e)",
          "%SBT reduction",
          "",
          "Comments",
          "",
        ]
      : ["Target year"];
  const cellColumnsNetZeroYear = [
    "Net zero year",
    "Emissions(tCO2e)",
    "%SBT reduction",
    "",
    "Comments",
    "",
  ];
  const targetCoverageList = [
    { label: "Common Target for total Scope 1, 2 & 3 emissions", id: 0 },
    {
      label: "Common Target for Scope 1 & 2; Separate Target for Scope 3",
      id: 1,
    },
    {
      label: "Separate Targets for Scope 1, Scope 2 and Scope 3",
      id: 2,
    },
    {
      label: "Separate Targets for all 23 categories", //individual scope 3 categories; Scope 1 & 2",
      id: 3,
    },
    // { label: "Separate targets for each category level", id: 4 },
    // { label: "Only Scope 1 & 2", id: 5 },
  ];
  const targetAlignmentList = [{ label: "SBTi 1.5", id: 0 }];

  const netZeroTarget = targetState.targets?.find(
    (eachTarget: any) => eachTarget.type === TARGET_TYPES.NET_ZERO
  );
  const mostRecentTarget = targetState.targets?.find(
    (eachTarget: any) => eachTarget.type === TARGET_TYPES.MOST_RECENT
  );
  const targetYears = targetState.targets?.filter(
    (eachTarget: any) => eachTarget.type === TARGET_TYPES.TARGET
  );
  const baselineYears = targetState.targets?.filter(
    (eachTarget: any) => eachTarget.type === TARGET_TYPES.BASELINE
  );

  // const handleSwitchChange = (
  //   checked: boolean,
  //   type: string,
  //   rowIdx: number
  // ) => {
  //   setSwitchStates((prevStates: { [x: string]: any }) => ({
  //     ...prevStates,
  //     [type]: {
  //       ...prevStates[type],
  //       [rowIdx]: checked,
  //     },
  //   }));
  // };

  let valueChanged = false;
  let scope1Val = 0,
    scope2Val = 0,
    scope3Val = 0;

  let coverageIndex = 0;
  useEffect(() => {
    if (isEdit) {
      let company =
        localStorage.getItem("company") &&
        JSON.parse(localStorage.getItem("company") || "{}").id;

      let categoriesList: any[] = [];
      emissionAvailableCategoriesService(company, true)
        .then((res) => {
          let categories = res.data.sort((a: any, b: any) =>
            a.code.localeCompare(b.code)
          );

          setCategoryList(categories);
          categoriesList = categories;

          let baselineValues = state.baseLineValues;
          let targets = state.targetYearValues;
          let recentValues = state.mostRecentYearValues;
          let zerovalues = state.netZeroValues;
          let facilityName = state.bunit_name;
          setBaseValues(baselineValues);
          setTargetValues(targets);
          setNetValues(zerovalues);

          const matchingTargetCoverage = targetCoverageList.find(
            (coverage) => coverage.label === baselineValues[0].target_coverage
          );

          if (matchingTargetCoverage) {
            setSelectedIndex(matchingTargetCoverage.id);
            coverageIndex = matchingTargetCoverage.id;
          }

          dispatch({
            type: TARGET_REDUCER_TYPES.SELECT_FACILITY,
            payload: {
              businessUnit: parseInt(id),
              businessUnitName: facilityName,
            },
          });

          setTargetCoverage(baselineValues[0].target_coverage);
          setTargetAlignment(zerovalues[0].target_alignment);

          baselineValues.forEach((eachBaseline: any) => {
            dispatch({
              type: TARGET_REDUCER_TYPES.ADD_BASELINE,
              payload: {
                type: "BASELINE",
                year: eachBaseline.target_year,
                id: eachBaseline.target_id,
                isUpdated: true,
                attachments: eachBaseline.target_attachments.files,
                comment: eachBaseline.target_comments,
                rowIdx: eachBaseline.target_scope
                  ? coverageIndex === 1 && eachBaseline.target_scope === 3
                    ? eachBaseline.target_scope - 2
                    : eachBaseline.target_scope - 1
                  : 0,
                scopeNum: eachBaseline.target_scope,
                metrics: eachBaseline.metrics,
                targetCoverageIndex: coverageIndex,
                categoryId:
                  coverageIndex === 3 ? eachBaseline?.emissions[0].category : 0,
              },
            });
          });

          baselineValues.forEach((eachBaseline: any) => {
            dispatch({
              type: TARGET_REDUCER_TYPES.UPDATE_TARGET,
              payload: {
                type: "BASELINE",
                year: eachBaseline.target_year,
                scope: eachBaseline.target_scope
                  ? eachBaseline.target_scope
                  : 1,
                value: eachBaseline.target_value,
                valueUpdated: true,
                id: eachBaseline.target_id,
                isUpdated: true,
                categoryId:
                  coverageIndex === 3 ? eachBaseline?.emissions[0].category : 0,
              },
            });
          });

          dispatch({
            type: TARGET_REDUCER_TYPES.UPDATE_TARGET,
            payload: {
              type: "MOST RECENT",
              year: recentValues[0].target_year,
              value: recentValues[0].target_value,
              id: recentValues[0].target_id,
              attachments: recentValues[0].target_attachments.files,
              comment: recentValues[0].target_comments,
              emissions: recentValues[0].emissions,
              isUpdated: true,
            },
          });

          targets.forEach((eachTarget: any) => {
            dispatch({
              type: TARGET_REDUCER_TYPES.ADD_TARGET,
              payload: {
                type: "TARGET",
                year: eachTarget.target_year,
                id: eachTarget.target_id,
                rowIdx: eachTarget.target_scope
                  ? coverageIndex === 1 && eachTarget.target_scope === 3
                    ? eachTarget.target_scope - 2
                    : eachTarget.target_scope - 1
                  : 0,
                attachments: eachTarget.target_attachments.files,
                comment: eachTarget.target_comments,
                targetCoverageIndex: coverageIndex,
                metrics: eachTarget.metrics,
                scopeNum: eachTarget.target_scope,
                categoryId:
                  coverageIndex === 3 ? eachTarget?.emissions[0].category : 0,
              },
            });
          });

          targets.forEach((eachTarget: any) => {
            dispatch({
              type: TARGET_REDUCER_TYPES.UPDATE_TARGET,
              payload: {
                type: "TARGET",
                year: eachTarget.target_year,
                prevYear: eachTarget.target_year,
                value: eachTarget.target_value,
                id: eachTarget.target_id,
                scope: eachTarget.target_scope ? eachTarget.target_scope : 1,
                percentage: eachTarget.target_reduction_percentage,
                isSBTiAligned: eachTarget.target_sbti_aligned,
                valueUpdated: true,
                isUpdated: true,
                categoryId:
                  coverageIndex === 3 ? eachTarget?.emissions[0].category : 0,
              },
            });
          });

          dispatch({
            type: TARGET_REDUCER_TYPES.UPDATE_TARGET,
            payload: {
              type: "NET ZERO",
              year: zerovalues[0]?.target_year,
              value: zerovalues[0]?.target_value,
              percentage: zerovalues[0]?.target_reduction_percentage,
              attachments: zerovalues[0]?.target_attachments.files,
              comment: zerovalues[0]?.target_comments,
              id: zerovalues[0]?.target_id,
              isUpdated: true,
            },
          });

          const updateCategoryList = (eachTarget: any, index: number) => {
            const scopeVal =
              eachTarget.target_type === "MOST_RECENT" ||
              eachTarget.target_type === "NET_ZERO"
                ? 0
                : eachTarget.target_type === "BASELINE" ||
                  eachTarget.target_type === "TARGET"
                ? eachTarget.target_scope || 1
                : 0;
            const filteredCategories = categoriesList.filter(
              (category: { code: CATEGORY_CODE; id: number | undefined }) => {
                return (
                  allowCategory(category.code, scopeVal, coverageIndex) &&
                  (coverageIndex < 3 ||
                    eachTarget.target_type === "MOST RECENT" ||
                    (eachTarget.target_type === "NET ZERO"
                      ? eachTarget.emissions.some(
                          (emission: { category: number | undefined }) =>
                            emission.category === category.id
                        )
                      : category.id === eachTarget.emissions[0].category))
                );
              }
            );
            console.log(filteredCategories, "filteredCategories");
            const updatedCategoryList = filteredCategories.map(
              (eachCat: any) => {
                const matchingEmission = eachTarget.emissions.find(
                  (eachEmission: any) => eachCat.id === eachEmission.category
                );
                if (matchingEmission) {
                  return {
                    ...eachCat,
                    id: matchingEmission.id,
                    category: matchingEmission.category,
                    year: matchingEmission.year,
                    value: matchingEmission.value,
                    scope: matchingEmission.scope,
                    included: matchingEmission.is_included,
                    sbtVal: matchingEmission.reduction_percentage,
                    attachments: matchingEmission.attachments.files,
                    comments: matchingEmission.comments,
                  };
                }
                return eachCat;
              }
            );

            const key = createKey(
              eachTarget.target_year,
              scopeVal,
              eachTarget.target_type === "MOST RECENT" ||
                eachTarget.target_type === "NET ZERO"
                ? 0
                : coverageIndex >= 3
                ? eachTarget.emissions[0].category
                : 0
            );
            setCategoriesByYears((prevData: Map<any, any>) => {
              const newData = new Map(prevData);
              newData.set(key, updatedCategoryList);
              calculateScopeValuesForTarget(
                updatedCategoryList,
                key,
                scopeVal,
                index,
                eachTarget.target_reduction_percentage,
                eachTarget.target_type
              );
              return newData;
            });
            setCategoryData((prevData: Map<any, any>) => {
              const newData = new Map(prevData);
              newData.set(key, updatedCategoryList);
              return newData;
            });
            setCategoryDataRecent((prevData: Map<any, any>) => {
              const newData = new Map(prevData);
              newData.set(key, updatedCategoryList);
              return newData;
            });
          };

          targets.forEach(updateCategoryList, matchingTargetCoverage?.id || 0);
          baselineValues.forEach(
            updateCategoryList,
            matchingTargetCoverage?.id || 0
          );
          recentValues.forEach(
            updateCategoryList,
            matchingTargetCoverage?.id || 0
          );
          zerovalues.forEach(
            updateCategoryList,
            matchingTargetCoverage?.id || 0
          );
        })
        .catch((err: { response: { data: { message: string } } }) => {
          toastMessage(err?.response?.data?.message, "error");
          console.log("Error:", err?.response?.data?.message);
        });
    }
  }, [state]);

  const calculateScopeValuesForTarget = (
    categories: any,
    key: string,
    scope: number,
    index: number,
    reductionPercentage: number,
    type: string
  ) => {
    let scope1Value = 0,
      scope2Value = 0,
      scope3Value = 0;

    categories.map((eachCat: any) => {
      if (eachCat.included) {
        if (eachCat.code.startsWith("Category 1")) {
          scope1Value += eachCat.value;
        } else if (eachCat.code.startsWith("Category 2")) {
          scope2Value += eachCat.value;
        } else {
          scope3Value += eachCat.value;
        }
      }
      return eachCat;
    });

    const scopeMap: { [key: string]: number } = {
      1:
        index === 0
          ? scope1Value + scope2Value + scope3Value
          : index === 1
          ? scope1Value + scope2Value
          : scope1Value,
      2: scope2Value,
      3: scope3Value,
    };

    {
      type === "TARGET"
        ? setScopewiseData((prevData: any) => ({
            ...prevData,
            [key]: {
              totalEmissionValue: parseFloat((scopeMap[scope] || 0).toFixed(3)),
              totalSbtValue: reductionPercentage,
              scopes: {
                scope1: parseFloat(scope1Value.toFixed(3)),
                scope2: parseFloat(scope2Value.toFixed(3)),
                scope3: parseFloat(scope3Value.toFixed(3)),
              },
              sbtValues: {
                sbt1: scope1Value <= 0 ? 0 : reductionPercentage,
                sbt2: scope2Value <= 0 ? 0 : reductionPercentage,
                sbt3: scope3Value <= 0 ? 0 : reductionPercentage,
              },
            },
          }))
        : setScopes((prevScopes) => {
            const updatedScopes = new Map(prevScopes);
            const yearScopes = updatedScopes.get(key) || {
              scope1: 0,
              scope2: 0,
              scope3: 0,
            };
            updatedScopes.set(key, {
              ...yearScopes,
              ["scope1"]: scope1Value,
              ["scope2"]: scope2Value,
              ["scope3"]: scope3Value,
            });
            return updatedScopes;
          });
    }
  };

  useEffect(() => {
    const reqObj = {
      emissionTarget: true,
    };
    fetchBusinessUnits(reqObj).then((res) => {
      const sortedBunits: [] = res.data.businessUnits;
      sortedBunits.sort((a: any, b: any) => a.name.localeCompare(b.name));
      setBunitsList([...sortedBunits]);
    });
  }, []);

  const handleDialogClose = () => {
    setOpenBaselineDialog(false);
    setOpenRecentDialog(false);
    setOpenTargetDialog(false);
    setOpenDialog(false);
  };

  const handleReset = (revertUseState: boolean) => {
    if (revertUseState) {
      dispatch({ type: TARGET_REDUCER_TYPES.RESET_STATE });
    }
  };

  const handleSelectionChange = (value: number) => {
    if (selectedIndex !== value && selectedIndex !== null) {
      handleReset(true);
    }
    setSelectedIndex(value);
    getCategoryList();
    setTargetCoverage(targetCoverageList[value].label);
    setTargetAlignment(targetAlignmentList[0].label);
  };

  const disabledDate: RangePickerProps["disabledDate"] = (current) => {
    return (
      current &&
      (current.year() < 2000 || current.year() > new Date().getFullYear())
    );
  };

  const disableBaselineYear: RangePickerProps["disabledDate"] = (current) => {
    const minYear = Math.min(...baselineYears.map((each: any) => each.year));
    return (
      current &&
      (current.year() - 1 < minYear - 1 ||
        current.year() > new Date().getFullYear())
    );
  };

  const disableTargetYear = (rowIdx: number, categoryId?: number) => {
    return (current: any) => {
      const baselineYear = baselineYears.find(
        (each: any) => each.rowIdx === rowIdx && each.categoryId === categoryId
      );
      return current && current.year() - 1 < baselineYear.year;
    };
  };

  const disableNetZeroYear: RangePickerProps["disabledDate"] = (current) => {
    return current && current.year() - 1 < new Date().getFullYear();
  };

  const onChangeUnit = (e: any) => {
    dispatch({
      type: TARGET_REDUCER_TYPES.SELECT_FACILITY,
      payload: {
        businessUnit: e,
        isUpdated: isEdit ? true : false,
        businessUnitName: bunitList?.find((eachUnit: any) => eachUnit.id === e)
          .name,
      },
    });
  };

  const getEmissionDetails = async (
    year: number,
    type?: string,
    scope?: number,
    categoryId?: number
  ) => {
    if (!year || !targetState?.businessUnitName) {
      return;
    }
    const from_date = moment().year(Number(year)).startOf("year").toISOString();
    const to_date = moment().year(Number(year)).endOf("year").toISOString();

    const reqObj = {
      businessUnitIds: targetState.businessUnit,
      from_date: moment(from_date).add(1, "day").toISOString(),
      to_date: moment(to_date).toISOString(),
      isSelected: true,
    };
    return getAllEmissionsService(reqObj)
      .then((res) => {
        setEmissionData(res.data);
        if (type === "BASELINE") {
          getAvailableCategories(
            res.data,
            TARGET_TYPES.BASELINE,
            year,
            scope,
            categoryId
          );
        } else getAvailableCategories(res.data, TARGET_TYPES.MOST_RECENT, year);
      })
      .catch((err) => {
        console.log("Error:", err?.response?.data?.message);
      });
  };

  const addBaseline = (
    year: number,
    index: number,
    rowIdx: number,
    categoryId?: number
  ) => {
    // setScope(rowIdx + 1);
    // setCategoryId(categoryId || undefined);
    if (!isNaN(year)) {
      // const existingBaseline = targetState.targets?.find(
      //   (baseline: { rowIdx: number; type: string; year: number }) =>
      //     baseline.type === TARGET_TYPES.BASELINE //&& baseline.year === year //&& baseline.rowIdx === rowIdx
      // );
      const existingBaseline = targetState.targets.find(
        (target: { type: TARGET_TYPES; rowIdx: any; categoryId: any }) => {
          if (selectedIndex < 3) {
            return (
              target.type === TARGET_TYPES.BASELINE && target.rowIdx === rowIdx
            );
          } else {
            return (
              target.type === TARGET_TYPES.BASELINE &&
              target.categoryId === categoryId &&
              target.rowIdx === rowIdx
            );
          }
        }
      );
      if (!existingBaseline) {
        dispatch({
          type: TARGET_REDUCER_TYPES.ADD_BASELINE,
          payload: {
            year: year,
            targetCoverageIndex: index,
            rowIdx: rowIdx,
            categoryId: categoryId,
            isUpdated: isEdit ? true : false,
            comment: "",
            attachments: [],
          },
        });
        setcurrentScope(rowIdx + 1);
        getEmissionDetails(
          year,
          TARGET_TYPES.BASELINE,
          selectedIndex === 1 && rowIdx === 1 ? rowIdx + 2 : rowIdx + 1,
          categoryId
        );
      } else {
        dispatch({
          type: TARGET_REDUCER_TYPES.UPDATE_TARGET,
          payload: {
            type: TARGET_TYPES.BASELINE,
            year: year,
            prevYear: existingBaseline.year,
            scope:
              selectedIndex === 1 && rowIdx === 1 ? rowIdx + 2 : rowIdx + 1,
            categoryId: categoryId,
          },
        });
        if (year != existingBaseline.year) {
          getEmissionDetails(
            year,
            TARGET_TYPES.BASELINE,
            selectedIndex === 1 && rowIdx === 1 ? rowIdx + 2 : rowIdx + 1,
            categoryId
          );
        }
      }
    }
  };

  const getReductionFactor = (targetYear: any, baselineYear: number) => {
    if (baselineYear <= 2020) {
      return 0.042;
    } else {
      return (0.042 * (targetYear - 2020)) / (targetYear - baselineYear);
    }
  };

  const addTarget = (
    year: number,
    index: number,
    rowIdx: number,
    categoryId?: number
  ) => {
    const baseline = baselineYears.find(
      (baseline: { rowIdx: number; categoryId: number }) =>
        selectedIndex >= 3
          ? baseline.rowIdx === rowIdx && baseline.categoryId === categoryId
          : baseline.rowIdx === rowIdx
    );

    if (!isNaN(year)) {
      let reductionFactor: number = getReductionFactor(year, baseline.year);
      let targetYearEmissions = parseFloat(
        (
          baseline.value *
          (1 - reductionFactor * (year - baseline.year))
        ).toFixed(2)
      );
      let percentReduction = baseline.value
        ? parseFloat(
            (
              ((baseline.value - targetYearEmissions) / baseline.value) *
              100
            ).toFixed(3)
          )
        : 0;
      dispatch({
        type: TARGET_REDUCER_TYPES.ADD_TARGET,
        payload: {
          type: "Target",
          year: year,
          isUpdated: isEdit ? true : false,
          emissionValue: targetYearEmissions < 0 ? 0 : targetYearEmissions,
          percentReduction:
            percentReduction > 100
              ? 100
              : percentReduction < 0
              ? 0
              : percentReduction,
          isSBTiAligned: true,
          comment: "",
          attachments: [],
          targetCoverageIndex: index,
          rowIdx: rowIdx,
          categoryId: categoryId,
        },
      });
    }
    setTargetYear(year);
    setTargetRowId(rowIdx);
    setCategoryIndex(categoryId || 0);
    //getCategoriesForTarget();
  };

  useEffect(() => {
    // When the targetYear state changes, this will run
    if (targetYear || targetRowId || categoryIndex) {
      getCategoriesForTarget();
    }
    setBaselineValueChanged(false);
  }, [targetYear, targetRowId, categoryIndex, baselineValueChanged]);

  const updateTarget = (
    dateString: string,
    prevYear: number,
    value: number,
    percentage: number,
    valueUpdated: boolean,
    isSBTiAligned: any,
    comment: string,
    attachments: [],
    type?: string,
    categoryIncluded?: boolean,
    rowIdx?: number,
    categoryId?: number
  ) => {
    const currYear = parseInt(dateString);
    const scope =
      selectedIndex === 1 && (rowIdx ?? 0) === 1
        ? (rowIdx ?? 0) + 2
        : (rowIdx ?? 0) + 1;
    dispatch({
      type: TARGET_REDUCER_TYPES.UPDATE_TARGET,
      payload: {
        type: type ? type : "TARGET",
        prevYear: prevYear,
        currYear: currYear,
        year: currYear,
        value: value,
        isUpdated: isEdit ? true : false,
        percentage: percentage,
        valueUpdated: valueUpdated,
        isSBTiAligned: isSBTiAligned,
        comment: comment,
        attachments: attachments,
        categoryIncluded: categoryIncluded,
        // scope: selectedIndex === 1 && targetRowId === 1 ? targetRowId+2 : targetRowId ? targetRowId+1 : -1,
        scope: scope,
        categoryId: categoryId,
      },
    });
  };

  const onChangeDate = (e: any, type: String) => {
    if (e && type === TARGET_TYPES.TARGET) {
      let yearAr = targetState.targets.filter(
        (each: any) => each.type === "TARGET"
      );
      yearAr.forEach((each: any) => {
        let year = each.year;
        dispatch({
          type: TARGET_REDUCER_TYPES.REMOVE_TARGET,
          payload: {
            type: "Target",
            year: year,
            isDeleted: isEdit ? true : false,
          },
        });
      });
    }
    dispatch({
      type: TARGET_REDUCER_TYPES.UPDATE_TARGET,
      payload: { type: type, year: e?.$y, isUpdated: isEdit ? true : false },
    });
    if (type === TARGET_TYPES.MOST_RECENT) {
      getEmissionDetails(e?.$y, type.toString());
    }
  };

  const filterUnits = (label: any, input: String) => {
    return (label.toString().toLowerCase() ?? "").includes(
      input.toString().toLowerCase()
    );
  };

  useEffect(() => {
    const reqObj = {
      emissionTarget: true,
    };
    fetchBusinessUnits(reqObj).then((res) => {
      if (res.data?.businessUnits?.length) {
        const bunitsStr = localStorage.getItem("bunits") || "";
        // If user has acces to create facility(Admin), then giving acces to create target to anu facility. Else only employee has association with that facility.
        const sortedBunits: [] = res.data.businessUnits.filter(
          (eachUnit: any) => {
            return (
              checkPermissions(["CREATE_FACILITY"], permissions) ||
              bunitsStr.includes(eachUnit.id)
            );
          }
        );
        sortedBunits.sort((a: any, b: any) => a.name.localeCompare(b.name));
        setBunitsList([...sortedBunits]);
      }
    });
  }, []);

  const handleOpenBaselineDialog = () => {
    setOpenBaselineDialog(true);
  };

  const handleOpenRecentDialog = () => {
    // alert("before check")
    // getAvailableCategories(
    //   emissionData,
    //   TARGET_TYPES.MOST_RECENT,
    //   mostRecentTarget.year
    // );
    setOpenRecentDialog(true);
  };

  const handleOpenTargetDialog = () => {
    setOpenTargetDialog(true);
  };

  const handleOpenDialog = (scope: number, type: string) => {
    setScopeToDisplay(scope);
    setCategoryTargetType(type);
    setOpenDialog(true);
  };

  function handleTargetYearChange(
    dateString: number,
    rowIdx: any,
    baselineYears: any[],
    eachTarget: any,
    categoryId: number
  ) {
    let year = dateString;
    const baseline = baselineYears.find((baseline: any) =>
      baseline.rowIdx === rowIdx && selectedIndex < 3
        ? true
        : baseline.categoryId === categoryId
    );
    let reductionFactor: number = getReductionFactor(year, baseline.year);
    let targetYearEmissions = parseFloat(
      (baseline.value * (1 - reductionFactor * (year - baseline.year))).toFixed(
        2
      )
    );
    let percentReduction = baseline.value
      ? parseFloat(
          (
            ((baseline.value - targetYearEmissions) / baseline.value) *
            100
          ).toFixed(3)
        )
      : 0;
    setTargetYear(year);
    setTargetRowId(rowIdx);
    setCategoryIndex(eachTarget?.categoryId || 0);
    return updateTarget(
      dateString.toString(),
      eachTarget.year,
      targetYearEmissions < 0 ? 0 : targetYearEmissions,
      percentReduction > 100
        ? 100
        : percentReduction < 0
        ? 0
        : percentReduction,
      true,
      true,
      eachTarget.comments,
      eachTarget.attachments,
      eachTarget.type,
      undefined,
      rowIdx,
      selectedIndex < 3 ? undefined : eachTarget?.categoryId
    );
  }

  const handleTableCellClick = (
    year: number,
    type: string,
    attachments: any,
    comments: string,
    categoryId?: number
  ) => {
    setShowFileUpload(true);
    setComments(comments);
    setCurrentTargetYear(year);
    setCurrentCategoryId(categoryId);
    setTargetType(type);
    setAttachmentsData({ attachments: [...attachments] });
  };

  const handleClose = () => {
    setShowFileUpload(false);
  };

  const handleFileUpload = (files: []) => {
    setAttachmentsData(() => {
      const target = targetState.targets.find(
        (target: any) =>
          target.categoryId === currentCategoryId && target.type === targetType
      );
      setIsCategoryAttachments(selectedIndex >= 3 ? true : false);
      updateTarget(
        targetType !== TARGET_TYPES.BASELINE
          ? ""
          : currentTargetYear.toString(),
        targetType === TARGET_TYPES.TARGET ? currentTargetYear : 0,
        0,
        0,
        false,
        null,
        comments,
        files,
        targetType,
        selectedIndex < 3 ? undefined : target?.included,
        selectedIndex < 3 ? undefined : target?.rowIdx,
        currentCategoryId
      );
      if (selectedIndex >= 3) {
        const key = createKey(target.year, target.scope, target.categoryId);

        setCategoriesByYears((prevData: Map<string, any[]>) => {
          const updatedData = new Map(prevData);
          const categories = updatedData.get(key);
          if (categories) {
            const categoryIndex = categories.findIndex(
              (category: { id: any }) => category.id === target.categoryId
            );
            if (categoryIndex !== -1) {
              categories[categoryIndex].attachments = files;
              updatedData.set(key, categories);
            }
          }
          return updatedData;
        });
      }
      return {
        attachments: files,
      };
    });
  };

  const handleDoubleClick = (
    year: string,
    scope: number,
    categoryId: number,
    column: string,
    value: number
  ) => {
    setEditableCell({ year, scope, categoryId, column });
    setEditedValue(value);
  };

  const handleValueChange = (event: any) => {
    if (/^\d*\.?\d*$/.test(event.target.value)) {
      setEditedValue(event.target.value);
    }
  };

  const handleValueSave = (
    year: string,
    prevVal: any,
    column: string,
    rowIdx: number,
    categoryId: number
  ) => {
    const baseline = baselineYears.find(
      (baseline: { rowIdx: number }) => baseline.rowIdx === rowIdx
    );
    let actualReductionFactor = getReductionFactor(
      parseInt(year),
      baseline.year
    );
    let actualtTargetYearEmissions = parseFloat(
      (
        baseline.value *
        (1 - actualReductionFactor * (parseInt(year) - baseline.year))
      ).toFixed(2)
    );

    let actualPercentReduction =
      ((baseline.value - actualtTargetYearEmissions) / baseline.value) * 100;

    if (column === "value") {
      let percent = parseFloat(
        (((baseline.value - editedValue) / baseline.value) * 100).toFixed(3)
      );
      updateTarget(
        "",
        parseInt(year),
        editedValue < 0 ? 0 : editedValue,
        percent > 100 ? 100 : percent < 0 ? 0 : percent,
        true,
        editedValue <= actualtTargetYearEmissions,
        "",
        [],
        TARGET_TYPES.TARGET,
        undefined,
        rowIdx,
        categoryId
      );
      setEditedValue(editedValue);
    } else if (column === "percentage") {
      let value =
        baseline.value && editedValue
          ? parseFloat(
              ((baseline.value * (100 - editedValue)) / 100).toFixed(2)
            )
          : 0;
      updateTarget(
        "",
        parseInt(year),
        value < 0 ? 0 : value,
        editedValue > 100 ? 100 : editedValue < 0 ? 0 : editedValue,
        true,
        editedValue >= actualPercentReduction,
        "",
        [],
        TARGET_TYPES.TARGET,
        undefined,
        rowIdx,
        categoryId
      );
      setEditedValue(editedValue);
    }
    setEditableCell(null);
    setTargetYear(parseInt(year));
    setTargetRowId(rowIdx);
    setCategoryIndex(categoryId);
    getCategoriesForTarget();
  };

  const updateValues = (
    emissionValue: number,
    baselineYear: number,
    scope?: number,
    categoryId?: number
  ) => {
    const baseline = targetState.targets?.find(
      (eachbaseline: any) =>
        eachbaseline.year === baselineYear &&
        // eachbaseline.scope === scope &&
        (selectedIndex !== null && selectedIndex < 3
          ? true
          : eachbaseline?.categoryId === categoryId)
    );
    const targetYrs = targetYears.filter(
      (eachtarget: { rowIdx: number; categoryId: number }) =>
        eachtarget.rowIdx === baseline.rowIdx && selectedIndex < 3
          ? true
          : eachtarget?.categoryId === baseline?.categoryId
    );
    const processTargetYears = (targetYrs: any[], index = 0) => {
      if (index >= targetYrs.length) return;

      const eachTarget = targetYrs[index];
      const year = eachTarget.year;
      let reductionFactor = getReductionFactor(year, baselineYear);
      let targetYearEmissions = parseFloat(
        (emissionValue * (1 - reductionFactor * (year - baselineYear))).toFixed(
          2
        )
      );
      let percentReduction =
        emissionValue && targetYearEmissions
          ? parseFloat(
              (
                ((emissionValue - targetYearEmissions) / emissionValue) *
                100
              ).toFixed(3)
            )
          : 0;
      updateTarget(
        "",
        year,
        targetYearEmissions < 0 ? 0 : targetYearEmissions,
        percentReduction > 100
          ? 100
          : percentReduction < 0
          ? 0
          : percentReduction,
        true,
        true,
        "",
        [],
        TARGET_TYPES.TARGET,
        undefined,
        eachTarget.rowIdx,
        categoryId
      );
      setBaselineValueChanged(true);
      setTargetYear(year);
      setTargetRowId(baseline.rowIdx);
      setCategoryIndex(baseline?.categoryId || 0);
      setTimeout(() => {
        processTargetYears(targetYrs, index + 1);
      }, 0);
    };
    processTargetYears(targetYrs);
  };

  const allowCategory = (code: CATEGORY_CODE, scope: number, index: number) => {
    if (scope === 1) {
      if (index > 1) {
        return (
          code >= CATEGORY_CODE.CATEGORY_1_1 &&
          code < CATEGORY_CODE.CATEGORY_2_1
        );
      } else if (index === 1) {
        return (
          code >= CATEGORY_CODE.CATEGORY_1_1 &&
          code < CATEGORY_CODE.CATEGORY_3_1
        );
      }
    } else if (scope === 2) {
      return (
        code >= CATEGORY_CODE.CATEGORY_2_1 && code < CATEGORY_CODE.CATEGORY_3_1
      );
    } else if (scope === 3) {
      return code >= CATEGORY_CODE.CATEGORY_3_1;
    }
    return true;
  };

  const getCategoryList = () => {
    let company =
      localStorage.getItem("company") &&
      JSON.parse(localStorage.getItem("company") || "{}").id;
    return emissionAvailableCategoriesService(company, true)
      .then((res) => {
        let categories = res.data.sort((a: any, b: any) =>
          a.code.localeCompare(b.code)
        );
        setCategoryList(categories);
      })
      .catch((err: { response: { data: { message: string } } }) => {
        toastMessage(err?.response?.data?.message, "error");
        console.log("Error:", err?.response?.data?.message);
      });
  };

  const updateScope = (
    scopeType: "scope1" | "scope2" | "scope3",
    value: number,
    key: string
  ) => {
    const roundedValue = parseFloat(value.toFixed(3));
    setScopes((prevScopes) => {
      const updatedScopes = new Map(prevScopes);
      const yearScopes = updatedScopes.get(key) || {
        scope1: 0,
        scope2: 0,
        scope3: 0,
      };
      updatedScopes.set(key, {
        ...yearScopes,
        [scopeType]: roundedValue,
      });
      return updatedScopes;
    });
  };

  const getAvailableCategories = (
    emissionData: any,
    type: any,
    year: any,
    scope?: number,
    categoryId?: number,
    categoryIncluded?: boolean
  ) => {
    let company =
      localStorage.getItem("company") &&
      JSON.parse(localStorage.getItem("company") || "{}").id;
    return emissionAvailableCategoriesService(company, true)
      .then((res) => {
        let categories = res.data.sort((a: any, b: any) =>
          a.code.localeCompare(b.code)
        );
        // let categories = categoryList;
        const key = createKey(year, scope || 0, categoryId || 0);

        let categoriesByYears = new Map();
        categoriesByYears.set(key, categories);

        categoriesByYears
          .get(key)
          .forEach(
            (eachCat: { value: any; code: string; included: boolean }) => {
              let sameSubCat = emissionData
                .flatMap((scope: { categories: any[] }) =>
                  scope.categories.flatMap((category) => category.subcategories)
                )
                .find(
                  (subcategory: { code: string }) =>
                    subcategory.code === eachCat.code
                );
              const newValue = sameSubCat
                ? parseFloat((sameSubCat.value / 1000).toFixed(3))
                : 0;

              if (eachCat.value !== newValue) {
                eachCat.value = newValue;
              }
              eachCat.included = true;
            }
          );

        const categoriesData =
          type === TARGET_TYPES.BASELINE
            ? categoryData.get(key) || []
            : categoryDataRecent.get(key) || [];

        categoriesData.forEach(
          (eachCat: {
            value: any;
            id: number;
            category: number;
            comments: string;
            included: boolean;
            attachments: any;
          }) => {
            let idx =
              eachCat.category && eachCat.id ? eachCat.category : eachCat.id;
            const existingCategoryIndex = categoriesByYears
              .get(key)
              .findIndex(
                (existingCategory: { id: number }) =>
                  existingCategory.id === idx
              );
            if (existingCategoryIndex !== -1) {
              const existingCategory =
                categoriesByYears.get(key)[existingCategoryIndex];
              if (existingCategory.value !== eachCat.value) {
                existingCategory.value = eachCat.value;
                valueChanged = true;
              }
              if (existingCategory.comments !== eachCat.comments) {
                existingCategory.comments = eachCat.comments;
              }
              if (existingCategory.included !== eachCat.included) {
                existingCategory.included = eachCat.included;
              }
              if (existingCategory.attachments !== eachCat.attachments) {
                existingCategory.attachments = eachCat.attachments;
              }
              if (eachCat.category && eachCat.id) {
                existingCategory.category = eachCat.category;
                existingCategory.id = eachCat.id;
              }
            }
          }
        );

        const target = targetState.targets?.find(
          (eachbaseline: { year: number; scope: number; categoryId: number }) =>
            eachbaseline.year === year &&
            eachbaseline.scope === scope &&
            (selectedIndex < 3 ? true : eachbaseline.categoryId === categoryId)
        );

        let categoryLevelValue = 0;
        categoriesByYears
          .get(key)
          .forEach(
            (eachCat: {
              value: any;
              code: any;
              included: boolean;
              id: number;
            }) => {
              if (selectedIndex < 3) {
                if (eachCat.code.startsWith("Category 1") && eachCat.included) {
                  scope1Val += parseFloat(eachCat.value);
                } else if (
                  eachCat.code.startsWith("Category 2") &&
                  eachCat.included
                ) {
                  scope2Val += parseFloat(eachCat.value);
                } else {
                  scope3Val += eachCat.included ? parseFloat(eachCat.value) : 0;
                }
              } else {
                if (eachCat.id === categoryId) {
                  categoryLevelValue = parseFloat(eachCat.value);
                }
              }
            }
          );

        updateScope("scope1", scope1Val, key);
        updateScope("scope2", scope2Val, key);
        updateScope("scope3", scope3Val, key);
        const totalEmissionValue = parseFloat(
          (scope1Val + scope2Val + scope3Val).toFixed(3)
        );

        let totalValue =
          target.scope === 1 && selectedIndex > 1
            ? scope1Val
            : target.scope === 2
            ? scope2Val
            : target.scope === 3
            ? scope3Val
            : target.scope === 1 && selectedIndex === 1
            ? scope1Val + scope2Val
            : scope1Val + scope2Val + scope3Val;
        totalValue = parseFloat(totalValue.toFixed(3));

        const categoryValue = categoryLevelValue;

        const updateCategories = (
          prevData: Map<any, any>,
          categoriesForYear: any[],
          key: any
        ) => {
          const newData = new Map(prevData);

          if (categoriesForYear) {
            const filteredCategories = categoriesForYear.filter(
              (category: { code: CATEGORY_CODE; id: number | undefined }) =>
                allowCategory(category.code, target.scope, selectedIndex) &&
                (selectedIndex < 3 || target.type === TARGET_TYPES.MOST_RECENT
                  ? true
                  : category.id === categoryId)
            );

            newData.set(key, filteredCategories);
          }

          return newData;
        };

        if (type === TARGET_TYPES.MOST_RECENT) {
          setMostRecentYearEmissionValue(totalEmissionValue);
          dispatch({
            type: TARGET_REDUCER_TYPES.UPDATE_TARGET,
            payload: {
              type: type,
              value: totalEmissionValue,
            },
          });
          setCategoryDataRecent((prevData) =>
            updateCategories(prevData, categoriesByYears.get(key), key)
          );
        } else {
          const value =
            selectedIndex < 3
              ? totalValue
              : categoryIncluded !== undefined && !categoryIncluded
              ? 0
              : categoryValue;
          dispatch({
            type: TARGET_REDUCER_TYPES.UPDATE_TARGET,
            payload: {
              type: TARGET_TYPES.BASELINE,
              year: year,
              scope: scope,
              value: value,
              valueUpdated: true,
              categoryId: categoryId,
            },
          });
          updateValues(value, year, scope, categoryId);
          setCategoryData((prevData) =>
            updateCategories(prevData, categoriesByYears.get(key), key)
          );
        }

        setCategoriesByYears((prevData: any) =>
          updateCategories(prevData, categoriesByYears.get(key), key)
        );

        return categoriesByYears.get(key);
      })
      .catch((err: { response: { data: { message: string } } }) => {
        toastMessage(err?.response?.data?.message, "error");
        console.log("Error:", err?.response?.data?.message);
      });
  };

  const getTargetEmission = (value: any, targetReductionFactor: number) => {
    if (value > 0) {
      let result = parseFloat(
        ((value * (100 - targetReductionFactor)) / 100).toFixed(2)
      );
      return result;
    } else {
      return 0;
    }
  };
  const getPercentageReduction = (
    targetYearEmission: any,
    emissionValue: any
  ) => {
    if (targetYearEmission > 0 && emissionValue > 0) {
      let percentReduction = parseFloat(
        (((emissionValue - targetYearEmission) / emissionValue) * 100).toFixed(
          3
        )
      );
      return percentReduction;
    } else {
      return 0;
    }
  };

  const getCategoriesForTarget = () => {
    let scope1Value = 0,
      scope2Value = 0,
      scope3Value = 0,
      sbt1Val = 0,
      sbt2Val = 0,
      sbt3Val = 0;
    let company =
      localStorage.getItem("company") &&
      JSON.parse(localStorage.getItem("company") || "{}").id;
    return emissionAvailableCategoriesService(company, true)
      .then((res) => {
        let categories = res.data.sort((a: any, b: any) =>
          a.code.localeCompare(b.code)
        );

        // let categories = categoryList;

        const targetScope =
          selectedIndex === 1 && targetRowId === 1
            ? targetRowId + 2
            : targetRowId
            ? targetRowId + 1
            : 1;
        const reqTarget = targetYears.find(
          (target: any) =>
            target.year === targetYear &&
            target.scope === targetScope &&
            (selectedIndex !== null && selectedIndex < 3
              ? true
              : target?.categoryId === categoryIndex)
        );
        const baseline = baselineYears.find(
          (baseline: { scope: string; categoryId: any }) =>
            baseline.scope === reqTarget?.scope &&
            (selectedIndex !== null && selectedIndex < 3
              ? true
              : baseline?.categoryId === categoryIndex)
        );

        const key = createKey(
          baseline?.year,
          baseline?.scope,
          baseline?.categoryId || 0
        );
        const emissionData = categoriesByYears.get(key);

        categories.map((eachCat: any) => {
          let sameSubCat = emissionData.find(
            (emission: { id: any; category: number; included: boolean }) =>
              emission.category && emission.id
                ? emission.category === eachCat.id
                : emission.id === eachCat.id //&& emission.included
          );
          if (sameSubCat) {
            if (sameSubCat?.included) {
              const val = getTargetEmission(
                sameSubCat.value,
                reqTarget.reductionPercentage
              );
              const sbtVal = getPercentageReduction(val, sameSubCat.value);

              eachCat.value = val;
              eachCat.sbtVal = sbtVal;
              eachCat.included = sameSubCat.included;
              if (eachCat.code.startsWith("Category 1")) {
                scope1Value += eachCat.value;
                sbt1Val += eachCat.sbtVal;
              } else if (eachCat.code.startsWith("Category 2")) {
                scope2Value += eachCat.value;
                sbt2Val += eachCat.sbtVal;
              } else {
                scope3Value += eachCat.value;
                sbt3Val += eachCat.sbtVal;
              }
            } else {
              eachCat.value = 0;
              eachCat.sbtVal = 0;
              eachCat.included = sameSubCat.included;
            }
          }
          return eachCat;
        });

        const scopeMap: { [key: string]: number } = {
          1:
            selectedIndex === 0
              ? scope1Value + scope2Value + scope3Value
              : selectedIndex === 1
              ? scope1Value + scope2Value
              : scope1Value,
          2: scope2Value,
          3: scope3Value,
        };

        // const sbtMap: { [key: string]: number } = {
        //   scope1: sbt1Val,
        //   1:
        //     selectedIndex === 0
        //       ? sbt1Val + sbt2Val + sbt3Val
        //       : selectedIndex === 1
        //       ? sbt1Val + sbt2Val
        //       : sbt1Val,
        //   2: sbt2Val,
        //   3: sbt3Val,
        // };

        const targetKey = createKey(
          reqTarget.year,
          reqTarget.scope,
          reqTarget?.categoryId || 0
        );
        setScopewiseData((prevData: any) => ({
          ...prevData,
          [targetKey]: {
            totalEmissionValue: parseFloat(
              (scopeMap[reqTarget.scope] || 0).toFixed(3)
            ),
            totalSbtValue: reqTarget.reductionPercentage,
            scopes: {
              scope1: parseFloat(scope1Value.toFixed(3)),
              scope2: parseFloat(scope2Value.toFixed(3)),
              scope3: parseFloat(scope3Value.toFixed(3)),
            },
            sbtValues: {
              sbt1: scope1Value <= 0 ? 0 : reqTarget.reductionPercentage,
              sbt2: scope2Value <= 0 ? 0 : reqTarget.reductionPercentage,
              sbt3: scope3Value <= 0 ? 0 : reqTarget.reductionPercentage,
            },
          },
        }));

        let targetEmissions = categoriesByYears.get(targetKey);

        const updatedCategories = !targetEmissions
          ? categories
          : categories.map((category: { id: number }) => {
              const sameEmission = targetEmissions.find(
                (targetEmission: { category: number; id: number }) =>
                  targetEmission.category === category.id
              );
              if (sameEmission) {
                return {
                  ...category,
                  category: sameEmission.category,
                  id: sameEmission.id,
                };
              }
              return category;
            });

        const filteredCategories = updatedCategories.filter(
          (category: { code: CATEGORY_CODE; id: number }) =>
            allowCategory(category.code, reqTarget.scope, selectedIndex) &&
            (selectedIndex < 3 ? true : category.id === categoryIndex)
        );

        setCategoriesByYears(
          (
            prevData: Iterable<readonly [unknown, unknown]> | null | undefined
          ) => {
            const newData = new Map(prevData || []);
            newData.set(
              createKey(
                reqTarget.year,
                reqTarget.scope,
                reqTarget?.categoryId || 0
              ),
              filteredCategories
            );
            console.log(newData, "newData");

            return newData;
          }
        );

        return categories;
      })
      .catch((err) => {
        toastMessage(err?.response?.data?.message, "error");
        console.log("Error:", err?.response?.data?.message);
      });
  };

  const updateEmissionData = () => {
    dispatch({
      type: TARGET_REDUCER_TYPES.ADD_EMISSIONS,
    });
  };

  useEffect(() => {
    updateEmissionData();
  }, [categoriesByYears]);

  const targetRows = ({
    targetYrs,
    rowIdx,
  }: {
    targetYrs: any[];
    rowIdx: number;
  }) => {
    return targetYrs?.length
      ? targetYrs.map((eachTarget: any, index: number) => (
          <TableRow key={index}>
            <TableCell>
              <div className="flex flex-row justify-between">
                <DatePicker
                  value={
                    eachTarget.year
                      ? dayjs(eachTarget.year.toString(), "YYYY")
                      : null
                  }
                  placeholder="Select"
                  id="pw-updateTarget-dropdown"
                  className="w-15"
                  onChange={(date, dateString) =>
                    handleTargetYearChange(
                      parseInt(dateString),
                      rowIdx,
                      baselineYears,
                      eachTarget,
                      eachTarget?.categoryId
                    )
                  }
                  picker="year"
                  disabledDate={disableTargetYear(
                    rowIdx,
                    eachTarget?.categoryId
                  )}
                  suffixIcon={<ArrowDropDownIcon />}
                  getPopupContainer={(trigger) =>
                    trigger.parentNode as HTMLElement
                  }
                />
                {selectedIndex < 3 ? (
                  // || switchStates[TARGET_TYPES.TARGET]?.[rowIdx] ? (
                  <div className="mt-2 ml-2">
                    <button
                      className="text-info-500"
                      onClick={() => {
                        handleOpenTargetDialog();
                        setCurrentTarget(eachTarget);
                        setSelectedTargetYear(eachTarget.year);
                      }}
                    >
                      Details
                    </button>
                  </div>
                ) : (
                  ""
                )}
              </div>
            </TableCell>
            <TableCell
              align="right"
              onClick={() =>
                handleDoubleClick(
                  eachTarget.year,
                  eachTarget.scope,
                  eachTarget?.categoryId || 0,
                  "value",
                  eachTarget.value || 0
                )
              }
            >
              {editableCell &&
              editableCell.year === eachTarget.year &&
              editableCell.scope === eachTarget.scope &&
              (selectedIndex >= 3
                ? editableCell.categoryId === eachTarget?.categoryId
                : true) &&
              editableCell.column === "value" ? (
                <TextField
                  value={editedValue}
                  onChange={handleValueChange}
                  onBlur={() =>
                    handleValueSave(
                      eachTarget.year,
                      eachTarget.value,
                      "value",
                      rowIdx,
                      eachTarget?.categoryId
                    )
                  }
                  inputProps={{ style: { padding: "0 8px", width: "fixed" } }}
                  autoFocus
                />
              ) : (
                eachTarget.value
              )}
            </TableCell>
            <TableCell
              align="right"
              onClick={() =>
                handleDoubleClick(
                  eachTarget.year,
                  eachTarget.scope,
                  eachTarget?.categoryId || 0,
                  "percentage",
                  eachTarget.reductionPercentage || 0
                )
              }
            >
              {editableCell &&
              editableCell.year === eachTarget.year &&
              editableCell.scope === eachTarget.scope &&
              (selectedIndex >= 3
                ? editableCell.categoryId === eachTarget?.categoryId
                : true) &&
              editableCell.column === "percentage" ? (
                <TextField
                  value={editedValue}
                  onChange={handleValueChange}
                  onBlur={() =>
                    handleValueSave(
                      eachTarget.year,
                      eachTarget.reductionPercentage,
                      "percentage",
                      rowIdx,
                      eachTarget?.categoryId
                    )
                  }
                  inputProps={{ style: { padding: "0 8px", width: "fixed" } }}
                  autoFocus
                />
              ) : (
                eachTarget.reductionPercentage
              )}
            </TableCell>
            <TableCell
              className="cursor-pointer"
              onClick={(e) => {
                handleTableCellClick(
                  eachTarget.year,
                  "TARGET",
                  eachTarget.attachments || [],
                  eachTarget.comment,
                  eachTarget?.categoryId
                );
              }}
            >
              <img src="assets/icons/FileUpload.svg" alt="File Upload" />
              {eachTarget?.attachments?.length > 0 ? (
                <sup className="text-xs bg-primary badge">
                  {eachTarget?.attachments?.length}
                </sup>
              ) : (
                ""
              )}
            </TableCell>
            <TableCell>
              <textarea
                name="hide"
                placeholder="Enter Comment"
                className="pw-textarea"
                value={eachTarget?.comment}
                onChange={(e) => {
                  updateTarget(
                    "",
                    eachTarget.year,
                    eachTarget.value,
                    eachTarget.reductionPercentage,
                    false,
                    null,
                    e.target.value,
                    [],
                    TARGET_TYPES.TARGET,
                    undefined,
                    rowIdx,
                    eachTarget?.categoryId
                  );

                  if (selectedIndex >= 3) {
                    const key = createKey(
                      eachTarget.year,
                      eachTarget.scope,
                      eachTarget.categoryId
                    );
                    setCategoriesByYears((prevData: Map<string, any[]>) => {
                      const updatedData = new Map(prevData);
                      const categories = updatedData.get(key);
                      if (categories) {
                        const categoryIndex = categories.findIndex(
                          (category: { id: any }) =>
                            category.id === eachTarget.categoryId
                        );
                        if (categoryIndex !== -1) {
                          categories[categoryIndex].comments = e.target.value;
                          updatedData.set(key, categories);
                        }
                      }
                      return updatedData;
                    });
                  }
                }}
              ></textarea>
            </TableCell>
            <TableCell className="cursor-pointer">
              <div className="flex flex-row justify-evenly text-s">
                {eachTarget.isSBTiAligned ? (
                  <img
                    src="assets/icons/successAlert.svg"
                    alt="Success Alert"
                  />
                ) : (
                  <img src="assets/icons/infoAlert.svg" alt="Info Alert" />
                )}{" "}
                SBTi 1.5
              </div>
            </TableCell>
          </TableRow>
        ))
      : "";
  };

  const renderBaselineTable = (count: number) => {
    return (
      <>
        {[...Array(count)].map((_, rowIdx) => {
          const relevantBaseline = baselineYears.find(
            (baseline: { rowIdx: number }) => baseline.rowIdx === rowIdx
          );
          return (
            <React.Fragment key={rowIdx}>
              <TableHead className="pw-activity-table-head">
                <TableRow>
                  {cellColumns.map((eachCell: any, index: number) => {
                    const displayContent = () => {
                      if (selectedIndex === 0) {
                        if (index === 0) {
                          return eachCell;
                        }
                      } else if (selectedIndex === 1) {
                        if (index === 0) {
                          return rowIdx === 0
                            ? "Baseline year Scope 1 & 2"
                            : "Baseline year Scope 3";
                        }
                      } else if (selectedIndex >= 2) {
                        if (index === 0) {
                          return rowIdx === 0
                            ? "Baseline year Scope 1"
                            : rowIdx === 1
                            ? "Baseline year Scope 2"
                            : "Baseline year Scope 3";
                        }
                      }
                      return eachCell;
                    };
                    return (
                      <TableCell
                        key={index}
                        className={`pw-activity-list ${
                          index === 0
                            ? "w-[284px]"
                            : index === 1
                            ? "w-[194px]"
                            : index === 2
                            ? "w-[36px]"
                            : "w-[203px]"
                        }`}
                        style={{ borderRight: "10px black" }}
                        align={index === 1 ? "center" : "left"}
                        colSpan={selectedIndex >= 3 ? 4 : 1}
                      >
                        {t(displayContent())}
                      </TableCell>
                    );
                  })}
                </TableRow>
              </TableHead>
              <TableBody>
                {/* {selectedIndex > 2 ? (
                  <TableRow>
                    <TableCell colSpan={4}>
                      <div className="flex flex-row justify-between">
                        <div className="text-s text-neutral-900">
                          Do all the scope {rowIdx + 1} categories have same
                          baseline year?
                        </div>
                        <div className="flex flex-row h-[24px] items-center justify-center text-sm gap-4">
                          <p>NO</p>
                          <Switch
                            style={{ color: `$primary` }}
                            checked={
                              switchStates[TARGET_TYPES.BASELINE]?.[rowIdx] ||
                              false
                            }
                            // checked={switchStates[TARGET_TYPES.BASELINE][rowIdx]}
                            onChange={(e) =>
                              handleSwitchChange(
                                e,
                                TARGET_TYPES.BASELINE,
                                rowIdx
                              )
                            }
                            size="small"
                          />
                          <p>YES</p>
                        </div>
                      </div>
                    </TableCell>
                  </TableRow>
                ) : (
                  <> </>
                )} */}
                {
                  // selectedIndex >= 3 &&
                  // switchStates[TARGET_TYPES.BASELINE]?.[rowIdx]) ||
                  selectedIndex < 3 ? (
                    <TableRow>
                      <TableCell
                        className={`pw-activity-list ${
                          relevantBaseline?.year < 2015 ? "bg-error-100" : ""
                        }`}
                      >
                        <div className="flex flex-row justify-between">
                          <DatePicker
                            value={
                              relevantBaseline
                                ? dayjs(
                                    relevantBaseline?.year.toString(),
                                    "YYYY"
                                  )
                                : null
                            }
                            id="pw-baseline-dropdown"
                            onChange={(date, dateString) => {
                              addBaseline(
                                parseInt(dateString),
                                selectedIndex,
                                rowIdx
                              );
                            }}
                            picker="year"
                            disabledDate={disabledDate}
                            suffixIcon={<ArrowDropDownIcon />}
                            disabled={!targetState?.businessUnitName}
                          />
                          <div className="mt-2">
                            <button
                              className={`text-info-500 ${
                                !relevantBaseline?.year
                                  ? "cursor-not-allowed"
                                  : "cursor-pointer"
                              }`}
                              onClick={() => {
                                setCurrentBaseline(
                                  relevantBaseline ? relevantBaseline : null
                                );
                                handleOpenBaselineDialog();
                                setBaselineYear(relevantBaseline?.year);
                              }}
                              disabled={!relevantBaseline?.year}
                            >
                              Enter Details
                            </button>
                          </div>
                        </div>
                        {relevantBaseline?.year < 2015 ? (
                          <div className="bg-error-100 text-error-500 p-1 mt-2">
                            The base year should not be earlier than 2015 or
                            later than the current year
                          </div>
                        ) : (
                          ""
                        )}
                      </TableCell>
                      <TableCell
                        align="right"
                        className={`${
                          relevantBaseline?.year < 2015 ? "bg-error-100" : ""
                        }`}
                      >
                        {relevantBaseline ? relevantBaseline.value : ""}
                      </TableCell>
                      <TableCell
                        className={` ${
                          relevantBaseline?.year
                            ? "cursor-pointer"
                            : "cursor-not-allowed"
                        }
                      ${relevantBaseline?.year < 2015 ? "bg-error-100" : ""}`}
                        onClick={
                          relevantBaseline?.year
                            ? () =>
                                handleTableCellClick(
                                  relevantBaseline?.year,
                                  TARGET_TYPES.BASELINE,
                                  relevantBaseline?.attachments || [],
                                  relevantBaseline?.comment
                                )
                            : () => {}
                        }
                      >
                        <img
                          src="assets/icons/FileUpload.svg"
                          className="ml-2.5"
                        />
                        {relevantBaseline?.attachments &&
                        relevantBaseline?.attachments.length > 0 ? (
                          <sup className=" text-xs bg-primary badge">
                            {relevantBaseline?.attachments?.length}
                          </sup>
                        ) : (
                          ""
                        )}
                      </TableCell>
                      <TableCell
                        className={`${
                          relevantBaseline?.year < 2015 ? "bg-error-100" : ""
                        }`}
                      >
                        <textarea
                          name="comment"
                          placeholder="Enter Comment"
                          className="pw-textarea"
                          disabled={!relevantBaseline?.year}
                          value={relevantBaseline?.comment}
                          onChange={(e) =>
                            updateTarget(
                              relevantBaseline.year,
                              0,
                              relevantBaseline?.value,
                              0,
                              false,
                              null,
                              e.target.value,
                              relevantBaseline?.attachments || [],
                              TARGET_TYPES.BASELINE
                            )
                          }
                        ></textarea>
                      </TableCell>
                    </TableRow>
                  ) : (
                    <TableRow>
                      <TableCell colSpan={4}>
                        <div className="flex flex-row justify-between">
                          <button
                            className=" text-info-500  cursor-pointer"
                            onClick={() =>
                              handleOpenDialog(
                                rowIdx + 1,
                                TARGET_TYPES.BASELINE
                              )
                            }
                          >
                            Enter details for scope {rowIdx + 1} categories
                          </button>
                        </div>
                      </TableCell>
                    </TableRow>
                  )
                }
              </TableBody>
            </React.Fragment>
          );
        })}
      </>
    );
  };

  const renderTargetTable = (count: number) => {
    return (
      <>
        {[...Array(count)].map((_, rowIdx) => {
          const isLastRow = rowIdx === count - 1;
          const targetYrs = targetYears.filter(
            (targetYrs: { rowIdx: number }) => targetYrs.rowIdx === rowIdx
          );
          return (
            <div
              key={rowIdx}
              className={`flex flex-col ${
                isLastRow ? "" : "pb-10 bg-neutral-100"
              }`}
            >
              <Card>
                <Table size="small" className="pw-activity-table">
                  <TableHead className="pw-activity-table-head">
                    <TableRow>
                      {cellColumnsTargetYear.map((eachCell, index) => {
                        const displayContent = () => {
                          if (selectedIndex === 0) {
                            if (index === 0) {
                              return eachCell;
                            }
                          } else if (selectedIndex === 1) {
                            if (index === 0) {
                              return rowIdx === 0
                                ? "Target year Scope 1 & 2"
                                : "Target year Scope 3";
                            }
                          } else if (selectedIndex >= 2) {
                            if (index === 0) {
                              return rowIdx === 0
                                ? "Target year Scope 1"
                                : rowIdx === 1
                                ? "Target year Scope 2"
                                : "Target year Scope 3";
                            }
                          }
                          return eachCell;
                        };

                        return (
                          <TableCell
                            key={index}
                            className={`pw-activity-list ${
                              index === 0
                                ? "w-44"
                                : index === 1
                                ? "w-32 bg-total-row"
                                : index === 2
                                ? "w-30 bg-total-row"
                                : index === 3
                                ? "w-12"
                                : index === 4
                                ? "w-52"
                                : "w-30"
                            }`}
                            align={index === 1 ? "center" : "left"}
                          >
                            {t(displayContent())}
                          </TableCell>
                        );
                      })}
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {/* {selectedIndex > 2 ? (
                      <TableRow>
                        <TableCell colSpan={6}>
                          <div className="flex flex-row justify-between">
                            <div className="text-s text-neutral-900">
                              Do all the scope {rowIdx + 1} categories have same
                              target years?
                            </div>
                            <div className="flex flex-row h-[24px] items-center justify-center text-sm gap-4">
                              <p>NO</p>
                              <Switch
                                style={{ color: `$primary` }}
                                checked={
                                  switchStates[TARGET_TYPES.TARGET]?.[rowIdx]
                                }
                                onChange={(e) =>
                                  handleSwitchChange(
                                    e,
                                    TARGET_TYPES.TARGET,
                                    rowIdx
                                  )
                                }
                                size="small"
                              />
                              <p>YES</p>
                            </div>
                          </div>
                        </TableCell>
                      </TableRow>
                    ) : (
                      <> </>
                    )} */}
                    {
                      // (selectedIndex > 2 &&
                      //   switchStates[TARGET_TYPES.TARGET]?.[rowIdx]) ||
                      selectedIndex < 3 ? (
                        <>
                          <>{targetRows({ targetYrs, rowIdx })}</>
                          <TableRow>
                            <TableCell>
                              <DatePicker
                                value={null}
                                placeholder="Select"
                                id="pw-target-dropdown"
                                className="w-15"
                                onChange={(date, dateString) => {
                                  addTarget(
                                    parseInt(dateString),
                                    selectedIndex,
                                    rowIdx
                                  );
                                }}
                                picker="year"
                                disabledDate={disableTargetYear(rowIdx)}
                                suffixIcon={<ArrowDropDownIcon />}
                                disabled={targetState.targets
                                  .filter(
                                    (target: {
                                      type: string;
                                      rowIdx: any;
                                      year: any;
                                    }) =>
                                      target.type === TARGET_TYPES.BASELINE &&
                                      target.rowIdx === rowIdx
                                  )
                                  .every(
                                    (target: { year: any }) => !target.year
                                  )}
                              />
                            </TableCell>
                            <TableCell />
                            <TableCell />
                            <TableCell />
                            <TableCell />
                            <TableCell />
                          </TableRow>
                        </>
                      ) : (
                        <TableRow>
                          <TableCell colSpan={6}>
                            <div className="flex flex-row justify-between">
                              <button
                                className=" text-info-500  cursor-pointer"
                                onClick={() =>
                                  handleOpenDialog(
                                    rowIdx + 1,
                                    TARGET_TYPES.TARGET
                                  )
                                }
                              >
                                Enter details for scope {rowIdx + 1} categories
                              </button>
                            </div>
                          </TableCell>
                        </TableRow>
                      )
                    }
                  </TableBody>
                </Table>
              </Card>
            </div>
          );
        })}
      </>
    );
  };

  return (
    <Fragment>
      <div className="pw-activity-data-main w-55v overflow-y-auto flex flex-col gap-10">
        <div>
          <div className="pw-input-label pw-create-label">
            {t("Emission targets")}
          </div>
          <div className="flex flex-row justify-between items-center pw-border-bottom pb-2">
            <div className="flex flex-row gap-1">
              <p className="text-sm text-neutral-600">
                {t("Emission Target Message")}
              </p>
            </div>
          </div>
        </div>
        <div>
          <div className="pw-range-label pb-1.5 text-neutral-600">
            {t("Facility")}
          </div>
          <AntSelect
            suffixIcon={<CaretDownOutlined className="!pointer-events-none" />}
            dropdownStyle={{ minWidth: "25%" }}
            showSearch
            style={{ width: 380 }}
            className="pw-source-select"
            placeholder={t("Select Facility")}
            onChange={(e) => onChangeUnit(e)}
            popupClassName="pw-target-bunit-dropdown"
            id="pw-target-bunit"
            filterOption={(input, option) => filterUnits(option?.label, input)}
            value={targetState?.businessUnitName}
            disabled={isEdit}
          >
            {bunitList?.map(({ name, id }: { name: String; id: number }) => (
              <Option key={id} value={id} label={name} className="pw-menu-item">
                {name}
              </Option>
            ))}
          </AntSelect>
        </div>
        <div>
          <div className="pw-range-label pb-1.5 text-neutral-600">
            {t("Target Coverage")}
          </div>

          <AntSelect
            suffixIcon={<CaretDownOutlined className="!pointer-events-none" />}
            dropdownStyle={{ minWidth: "25%" }}
            showSearch
            style={{ width: 380 }}
            className="pw-source-select"
            placeholder={t("Target Coverage")}
            onChange={handleSelectionChange}
            popupClassName="pw-target-bunit-dropdown"
            id="pw-target-coverage"
            filterOption={(input, option) => filterUnits(option?.label, input)}
            value={selectedIndex}
            disabled={isEdit}
            defaultActiveFirstOption
          >
            {targetCoverageList.map(({ label, id }) => (
              <Option key={id} value={id} className="pw-menu-item">
                {label}
              </Option>
            ))}
          </AntSelect>
        </div>
        <div>
          <div className="pw-range-label pb-1.5 text-neutral-600">
            {t("Target Alignment")}
          </div>
          <AntSelect
            suffixIcon={<CaretDownOutlined className="!pointer-events-none" />}
            dropdownStyle={{ minWidth: "25%" }}
            showSearch
            style={{ width: 380 }}
            className="pw-source-select"
            placeholder={t("Target Alignment")}
            popupClassName="pw-target-bunit-dropdown"
            id="pw-target-alignment"
            filterOption={(input, option) => filterUnits(option?.label, input)}
            disabled={isEdit}
            defaultValue={"SBTi 1.5"}
          >
            {targetAlignmentList.map(({ label, id }) => (
              <Option key={id} value={id} className="pw-menu-item">
                {label}
              </Option>
            ))}
          </AntSelect>
        </div>
        <div className="flex flex-col gap-10">
          <div>
            <Card>
              <Table size="small" className="pw-activity-table">
                {selectedIndex >= 2 ? (
                  <>{renderBaselineTable(3)}</>
                ) : selectedIndex === 1 ? (
                  <>{renderBaselineTable(2)}</>
                ) : (
                  <>{renderBaselineTable(1)}</>
                )}

                <TableHead className="pw-activity-table-head">
                  <TableRow>
                    {cellColumnsRecentYear.map((eachCell, index) => (
                      <TableCell
                        key={index}
                        className={`pw-activity-list ${
                          index === 0
                            ? "pw-zero-row-target"
                            : index === 1
                            ? "pw-first-row-target"
                            : index === 2
                            ? " w-12"
                            : "pw-last-row-target"
                        }`}
                        align={index === 1 ? "center" : "left"}
                      >
                        {t(eachCell)}
                      </TableCell>
                    ))}
                  </TableRow>
                </TableHead>
                <TableBody>
                  <TableCell>
                    <div className="flex flex-row justify-between">
                      <DatePicker
                        value={
                          mostRecentTarget.year
                            ? dayjs(mostRecentTarget.year.toString(), "YYYY")
                            : null
                        }
                        id="pw-recent-dropdown"
                        onChange={(e: any) => {
                          onChangeDate(e, TARGET_TYPES.MOST_RECENT);
                        }}
                        picker="year"
                        disabledDate={disableBaselineYear}
                        suffixIcon={<ArrowDropDownIcon />}
                        disabled={
                          !targetState?.businessUnitName ||
                          (selectedIndex !== 3 &&
                            targetState?.targets?.filter(
                              (target: any) =>
                                target.type === TARGET_TYPES.BASELINE
                            )?.length !==
                              selectedIndex + 1)
                        }
                      />
                      <div className="mt-2">
                        <button
                          className={`text-info-500 ${
                            !mostRecentTarget.year
                              ? "cursor-not-allowed"
                              : "cursor-pointer"
                          }`}
                          onClick={handleOpenRecentDialog}
                          disabled={!mostRecentTarget.year}
                        >
                          Enter Details
                        </button>
                      </div>
                    </div>
                  </TableCell>
                  <TableCell align="right">
                    {" "}
                    {mostRecentTarget?.value}
                  </TableCell>
                  <TableCell
                    align="center"
                    onClick={
                      mostRecentTarget?.year
                        ? () =>
                            handleTableCellClick(
                              mostRecentTarget.year,
                              TARGET_TYPES.MOST_RECENT,
                              mostRecentTarget.attachments || [],
                              mostRecentTarget.comment
                            )
                        : () => {}
                    }
                    className={`${
                      mostRecentTarget.year
                        ? "cursor-pointer flex items-center"
                        : "cursor-not-allowed"
                    }`}
                  >
                    <img src="assets/icons/FileUpload.svg" className="ml-2.5" />
                    {mostRecentTarget.attachments &&
                    mostRecentTarget.attachments.length > 0 ? (
                      <sup className=" text-xs bg-primary badge">
                        {mostRecentTarget.attachments?.length}
                      </sup>
                    ) : (
                      ""
                    )}
                  </TableCell>
                  <Dialog
                    open={showFileUpload}
                    onClose={handleClose}
                    className="pw-attachment-dialog"
                  >
                    <div>
                      <div className="pb-6">
                        <div className="pw-header-text">Add attachments</div>
                        <div
                          onClick={handleClose}
                          style={{
                            cursor: "pointer",
                            textAlign: "right",
                            marginTop: "-30px",
                          }}
                        >
                          <CancelIcon />
                        </div>
                      </div>
                      <FileAttachmentsDetails
                        formData={attachmentsData}
                        setFormData={(updatedFormData: any) =>
                          handleFileUpload(updatedFormData.attachments)
                        }
                      />
                    </div>
                  </Dialog>
                  <TableCell>
                    <textarea
                      name="hide"
                      placeholder="Enter Comment"
                      className="pw-textarea"
                      disabled={!mostRecentTarget.year}
                      value={mostRecentTarget?.comment}
                      onChange={(e) =>
                        updateTarget(
                          "",
                          0,
                          mostRecentTarget.value,
                          0,
                          false,
                          null,
                          e.target.value,
                          mostRecentTarget.attachments || [],
                          TARGET_TYPES.MOST_RECENT
                        )
                      }
                    ></textarea>
                  </TableCell>
                </TableBody>
              </Table>
            </Card>
          </div>

          <div>
            <Card>
              {selectedIndex >= 2 ? (
                <>{renderTargetTable(3)}</>
              ) : selectedIndex === 1 ? (
                <>{renderTargetTable(2)}</>
              ) : (
                <>{renderTargetTable(1)}</>
              )}
            </Card>
          </div>

          <div>
            <Card>
              <Table size="small" className="pw-activity-table">
                <TableHead className="pw-activity-table-head">
                  <TableRow>
                    {cellColumnsNetZeroYear.map((eachCell, index) => (
                      <TableCell
                        key={index}
                        className={`pw-activity-list ${
                          index === 0
                            ? "w-44"
                            : index === 1
                            ? "w-32"
                            : index === 2
                            ? "w-40"
                            : index === 3
                            ? "w-12"
                            : index === 4
                            ? "w-52"
                            : "w-20"
                        }`}
                        align={index === 1 ? "center" : "left"}
                      >
                        {t(eachCell)}
                      </TableCell>
                    ))}
                  </TableRow>
                </TableHead>
                <TableBody>
                  <TableRow>
                    <TableCell>
                      <div className="flex flex-row justify-between">
                        <DatePicker
                          value={
                            netZeroTarget.year
                              ? dayjs(netZeroTarget.year.toString(), "YYYY")
                              : null
                          }
                          placeholder="Select"
                          id="pw-netzero-dropdown"
                          className="w-15"
                          onChange={(e: any) =>
                            onChangeDate(e, TARGET_TYPES.NET_ZERO)
                          }
                          picker="year"
                          disabledDate={disableNetZeroYear}
                          suffixIcon={<ArrowDropDownIcon />}
                          disabled={
                            ![
                              TARGET_TYPES.BASELINE,
                              TARGET_TYPES.MOST_RECENT,
                              TARGET_TYPES.TARGET,
                            ].every((type) =>
                              targetState.targets.some(
                                (target: { type: string; year: any }) =>
                                  target.type === type
                              )
                            )
                          }
                        />
                        <div className="mt-2 ml-2">
                          <button
                            className="text-info-500"
                            //onClick={handleCall}
                          >
                            {/* Details */}
                          </button>
                        </div>
                      </div>
                    </TableCell>
                    <TableCell align="right">
                      {netZeroTarget.year ? 0 : ""}
                    </TableCell>
                    <TableCell align="right">
                      {netZeroTarget.year ? 100 : ""}
                    </TableCell>
                    <TableCell
                      onClick={
                        netZeroTarget?.year
                          ? () =>
                              handleTableCellClick(
                                netZeroTarget?.year,
                                TARGET_TYPES.NET_ZERO,
                                netZeroTarget?.attachments || [],
                                netZeroTarget?.comment
                              )
                          : () => {}
                      }
                      className={`${
                        netZeroTarget.year
                          ? "cursor-pointer"
                          : "cursor-not-allowed"
                      }`}
                    >
                      <img
                        src="assets/icons/FileUpload.svg"
                        className="ml-1.5"
                      />
                      {netZeroTarget?.attachments &&
                      netZeroTarget.attachments.length > 0 ? (
                        <sup className=" text-xs bg-primary badge">
                          {netZeroTarget.attachments?.length}
                        </sup>
                      ) : (
                        ""
                      )}
                    </TableCell>
                    <TableCell>
                      <textarea
                        name="comment"
                        placeholder="Enter Comment"
                        className="pw-textarea"
                        disabled={!netZeroTarget.year}
                        value={netZeroTarget?.comment}
                        onChange={(e) =>
                          updateTarget(
                            "",
                            0,
                            0,
                            0,
                            false,
                            null,
                            e.target.value,
                            [],
                            TARGET_TYPES.NET_ZERO
                          )
                        }
                      ></textarea>
                    </TableCell>
                    <TableCell></TableCell>
                  </TableRow>
                </TableBody>
              </Table>
            </Card>
          </div>
        </div>
      </div>
      <div className="flex flex-row justify-end pw-bunit-footer w-full gap-6">
        <div
          className="pw-bunit-button-light pw-bunit-button-next text-neutral bg-white font-bold"
          onClick={() => navigate("/targets")}
        >
          {t("Cancel")}
        </div>
        <button
          className={`pw-bunit-button-primary pw-bunit-button-save text-white ${
            targetState.error.targetValid ? "bg-primary" : "bg-neutral-200"
          }`}
          onClick={() => {
            setStep(STEPS.METRICS);
          }}
          disabled={!targetState.error.targetValid}
        >
          {t("Next")}
        </button>
      </div>
      {OpenBaselineDialog && (
        <BaselineYearDialog
          open={OpenBaselineDialog}
          onClose={handleDialogClose}
          currentBaseline={currentBaseline}
          year={baselineYear}
          emissionData={emissionData}
          getAvailableCategories={getAvailableCategories}
          categoryData={categoryData}
          setCategoryData={setCategoryData}
          categoriesByYears={categoriesByYears}
          scopes={scopes}
          currentScope={currentScope}
          selectedIndex={selectedIndex}
          targetState={targetState}
          baselineYears={baselineYears}
          createKey={createKey}
        ></BaselineYearDialog>
      )}
      {OpenRecentDialog && (
        <RecentYearDialog
          open={OpenRecentDialog}
          onClose={handleDialogClose}
          year={mostRecentTarget.year}
          emissionData={emissionData}
          getAvailableCategories={getAvailableCategories}
          categoryData={categoryDataRecent}
          setCategoryData={setCategoryDataRecent}
          scopes={scopes}
          createKey={createKey}
        ></RecentYearDialog>
      )}
      {OpenTargetDialog && (
        <TargetYearDialog
          open={OpenTargetDialog}
          onClose={handleDialogClose}
          currentTarget={currentTarget}
          year={selectedTargetYear}
          scopewiseData={scopewiseData}
          categoriesByYears={categoriesByYears}
          createKey={createKey}
        ></TargetYearDialog>
      )}
      {OpenDialog && (
        <CategoryLevelDialog
          open={OpenDialog}
          onClose={handleDialogClose}
          categoryList={categoryList}
          scope={scopeToDisplay}
          type={categoryTargetType}
          targetState={targetState}
          baselineYears={baselineYears}
          targetYears={targetYears}
          addBaseline={addBaseline}
          addTarget={addTarget}
          getAvailableCategories={getAvailableCategories}
          categoryData={categoryData}
          setCategoryData={setCategoryData}
          updateTarget={updateTarget}
          targetRows={targetRows}
          createKey={createKey}
          handleTableCellClick={handleTableCellClick}
          categoryAttachments={isCategoryAttachments}
          selectedIndex={selectedIndex}
          rowIdx={scopeToDisplay - 1}
          disabledDate={disabledDate}
          disableTargetYear={disableTargetYear}
        ></CategoryLevelDialog>
      )}
    </Fragment>
  );
};

export default EmissionTarget;
